import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const IdRetencionFormGroup = ({
  values,
  setValues,
  iError,
  iTouched,
  fIsSubmitting,
  retenciones
}) => {
  const [fieldDisabled, setFieldDisabled] = React.useState(values._idRetencion === '')

  const checkDetraccionHandler = () => {
    if (!fieldDisabled) {
      values._idRetencion = ''
      setValues(values)
    }

    setFieldDisabled(prevState => {
      return !prevState
    })
  }

  return (
    <Form.Group>
      <Form.Label
        text='RETENCIÓN'
        htmlFor='select-idDetraccion'
        sm={2}
        md={3}
        lg={2}
        alignRightAt='sm'
      />
      <Col sm={10} md={9} lg={10}>
        <Form.InputGroup>
          <Form.InputGroup.Prepend>
            <Form.InputGroup.Checkbox
              aria-label='Checkbox for following text input'
              checked={!fieldDisabled || values._idRetencion !== ''}
              onChange={checkDetraccionHandler}
            />
          </Form.InputGroup.Prepend>
          <Field name='_idRetencion'>
            {({ field }) => (
              <Form.Select
                {...field}
                disabled={fIsSubmitting || fieldDisabled}
                isInvalid={iTouched && iError}
                id='select-idRetencion'
              >
                <option value=''>Seleccionar</option>
                {retenciones &&
                  retenciones.map((val, key) => (
                    <option key={key} value={val._id}>
                      {val.nombre}
                    </option>
                  ))}
              </Form.Select>
            )}
          </Field>
        </Form.InputGroup>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdRetencionFormGroup)
